module.exports = "/fonts/Lato-Medium.ttf";